// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23ENC","toggle":"styles_toggle__2Y30E","preview":"styles_preview__3eluU"};